import { provideFetchPlanList } from '~/api-core/Subscription/Plan'

import type { Plan } from '~/types/Subscription'

export const useSubscriptionStore = defineStore('subscription', () => {
  const { coreFetch } = useProvideCoreFetch()

  const plans = ref<Plan[]>([
    // mocked data for now
    {
      id: 2,
      stripe_id: 'plan_2',
      price: 215.88,
      currency: 'USD',
      interval: 'year',
      slug: 'groover-plus-yearly',
      promo_code: 'GROOVER+',
      benefits: {
        'unlimited-hype': true,
        'unlimited-charts': true,
        'fifteen-percent-off': true,
        'exclusive-opportunities': true,
        'prioritized-team-support': true,
        'cancel-anytime': true,
      },
    },
    {
      id: 1,
      stripe_id: 'plan_1',
      price: 25.99,
      currency: 'USD',
      interval: 'month',
      slug: 'groover-plus-monthly',
      promo_code: 'GROOVER+',
      benefits: {
        'unlimited-hype': true,
        'unlimited-charts': true,
        'fifteen-percent-off': false,
        'exclusive-opportunities': true,
        'prioritized-team-support': true,
        'cancel-anytime': true,
      },
    },
  ])

  async function FETCH_PLANS() {
    plans.value = await provideFetchPlanList(coreFetch)()
  }

  function GET_PLAN_BY_SLUG(slug: Plan['slug']) {
    return plans.value.find((plan) => plan.slug === slug)
  }

  function GET_PLAN_BY_STRIPE_ID(stripeId: Plan['stripe_id']) {
    return plans.value.find((plan) => plan.stripe_id === stripeId)
  }

  return {
    plans,

    FETCH_PLANS,
    GET_PLAN_BY_SLUG,
    GET_PLAN_BY_STRIPE_ID,
  }
})
